import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from 'react-i18next';

const SecurityStatusIcon = ({ status }: { status: string }) => {
	const { t } = useTranslation();

	const statusValue = status.toLowerCase().replaceAll(' ', '');

	if (statusValue === 'secure') {
		return (
			<Tooltip title={t('bsn:status:secure')}>
				<img src={`${process.env.PUBLIC_URL}/assets/images/bsn/bsn-secure-icon-tables.svg`} alt="" />
			</Tooltip>
		);
	}

	if (statusValue === 'unsecured' || statusValue === 'notsecure') {
		return (
			<Tooltip title={t('bsn:status:insecure')}>
				<img src={`${process.env.PUBLIC_URL}/assets/images/bsn/bsn-unsecure-icon-tables.svg`} alt="" />
			</Tooltip>
		);
	}

	return (
		<Tooltip title={t('bsn:status:unknown')}>
			<img src={`${process.env.PUBLIC_URL}/assets/images/bsn/bsn-unknown-icon-tables.svg`} alt="" />
		</Tooltip>
	);
};

export default SecurityStatusIcon;
